<template>
    <div class="a-modal">
        <div class="popup__header popup__header--border">
            <span class="title title--sm popup__title">{{ $route.params.id ? $lang('master.addResponsible.title'): $lang('master.addResponsible.title2')}}</span>
        </div>
        <form class="form" @submit.prevent="submit" ref="form">
            <div class="popup__content">
                <div class="form__item">
                    <span class="form__label">{{ $lang('master.addResponsible.respData') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input dusk="name" slot="reference" :class="{ 'add__error': errors.name.isErrorPaint }" @focus="clearErrors"
                                  :placeholder="$lang('master.addResponsible.name.placeholder')" class="input input--big" v-model="form.name"></el-input>
                    </el-popover>
                    <span class="a-modal__hint">{{ $lang('master.addResponsible.name.hint') }}</span>
                </div>
                <div class="form__item a-modal__big">
                    <el-popover :value="errors.phone.isError || errors.phone_md5.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.phone.message || errors.phone_md5.message">
                        <input-phone slot="reference"
                                     :class="{ 'add__error': errors.phone.isErrorPaint || errors.phone_md5.isErrorPaint }"
                                     @focus="clearErrors"
                                     :placeholder="$lang('master.addResponsible.phone.placeholder')"
                                     class="input input--big"
                                     v-model="form.phone"/>
                    </el-popover>
                    <span class="a-modal__hint">{{ $lang('master.addResponsible.phone.hint') }}</span>
                </div>
                <div class="form__item a-modal__big">
                    <el-popover :value="errors.email.isError || errors.email_md5.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.email.message || errors.email_md5.message">
                        <el-input dusk="email"
                                  slot="reference"
                                  :class="{ 'add__error': errors.email.isErrorPaint || errors.email_md5.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('master.addResponsible.email.placeholder')"
                                  class="input input--big"
                                  v-model="form.email"/>
                    </el-popover>
                    <span class="a-modal__hint">{{ $lang('master.addResponsible.email.hint') }}</span>
                </div>
            </div>
            <div class="popup__footer">
                <button dusk="create-button" class="btn btn--middle btn--main-bg">{{ id ? $lang('master.addResponsible.save') : $lang('master.addResponsible.add') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import errors from '../../../mixins/errors';
    import InputPhone from "../../../components/InputPhone";
    import Vue from "vue";

    const FROM = {
        name: '',
        email: '',
        phone: '',
        password: Math.random().toString(36).slice(-8),
        master_id: null,
        partner_id: null,
        id: null,
        clone: () => JSON.parse(JSON.stringify(FROM))
    }

    export default {
        name: "AddResponsible",
        mixins: [errors],
        components: {InputPhone},
        data: () => ({
            form: FROM.clone(),
            errors: {
                name: {
                    isError: false,
                    message: ''
                },
                email: {
                    isError: false,
                    message: ''
                },
                email_md5: {
                    isError: false,
                    message: ''
                },
                phone: {
                    isError: false,
                    message: ''
                },
                phone_md5: {
                    isError: false,
                    message: ''
                },
            }
        }),
        computed: {
            ...mapState('auth',[
                'user'
            ]),
            id() {
                return this.$route.params.id;
            }
        },
        mounted() {
            if (this.$route.params.responsible) {
                this.form.email = this.$route.params.responsible.email;
                this.form.phone = this.$route.params.responsible.phone;
                this.form.name = this.$route.params.responsible.name;
                this.form.id = this.$route.params.responsible.id;
            }

            this.form.master_id = this.user.id;
            this.form.partner_id = this.user.partner_id;
        },
        methods: {
            ...mapActions('user', [
                'createUser',
                'editUser',
            ]),
            submit() {
                this.$loading(this.$optionsLoading);

                console.log('click button create-button');

                if (this.id) {
                    this.edit();
                } else {
                    this.create();
                }
            },
            create() {
                const vue = this;

                this.createUser(this.form)
                    .then((response) => {
                        this.$appNotify.success(Vue.prototype.$lang('master.addResponsible.success'));
                        vue.form = FROM.clone();
                        this.$router.push({name:'master-responsibles'});
                    }).catch((error) => {
                        this.createErrors(error?.response?.data?.errors);
                    }).finally(() => {
                        this.$loading({}).close();
                    });
            },
            edit() {
                const vue = this;

                this.editUser(this.form)
                    .then((response) => {
                        this.$appNotify.success(Vue.prototype.$lang('master.addResponsible.success2'));
                        vue.form = FROM.clone();
                        this.$router.push({name:'master-responsibles'});
                    }).catch((error) => {
                        this.createErrors(error?.response?.data?.errors);
                    }).finally(() => {
                        this.$loading({}).close();
                    });
            }
        }
    }
</script>
